module.exports = __webpack_public_path__ + "img/facilityInfo_2_0.f77cab09.jpg";